'use client';
import { jsx } from 'react/jsx-runtime';
import { ButtonbarContext } from './buttonbar.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(o = 0; o < l.length; o++)r = l[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, l = Object.keys(e);
    for(o = 0; o < l.length; o++)r = l[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
function isSingleSelect(e) {
    return 'single-select' === e.variant || null == e.variant;
}
let removeSelectionProps = (e)=>{
    if (isSingleSelect(e)) {
        let { selectedValue: t, onSelectedValueChange: r, defaultSelectedValue: o } = e;
        return _object_without_properties(e, [
            "selectedValue",
            "onSelectedValueChange",
            "defaultSelectedValue"
        ]);
    }
    {
        let { selectedValues: t, onSelectedValuesChange: r, defaultSelectedValues: o } = e;
        return _object_without_properties(e, [
            "selectedValues",
            "onSelectedValuesChange",
            "defaultSelectedValues"
        ]);
    }
}, useButtonbarState = (e)=>{
    let t, r, n, l;
    let a = null;
    isSingleSelect(e) && (t = e.selectedValue, r = e.onSelectedValueChange, a = e.defaultSelectedValue);
    let [c, u] = useControllableValue({
        value: null != t ? t : void 0,
        onChange: null != r ? r : void 0,
        defaultValue: a,
        defaultOnChange: (e, ...t)=>{
            let [r] = t;
            e(r);
        }
    }), i = null;
    isSingleSelect(e) || (n = e.selectedValues, l = e.onSelectedValuesChange, i = e.defaultSelectedValues);
    let [s, p] = useControllableValue({
        value: null != n ? n : void 0,
        onChange: null != l ? l : void 0,
        defaultValue: i || [],
        defaultOnChange: (e, ...t)=>{
            let [r] = t;
            e(r);
        }
    });
    return {
        selectedValue: c,
        onSelectedValueChange: u,
        selectedValues: s,
        onSelectedValuesChange: p
    };
};
const Buttonbar = renderWithRef('Buttonbar', null, (r, o)=>{
    let a = removeSelectionProps(r), { children: c, variant: u = 'single-select', width: i = 'standard', 'aria-label': s, 'aria-controls': p, name: b } = a, d = _object_without_properties(a, [
        "children",
        "variant",
        "width",
        'aria-label',
        'aria-controls',
        "name"
    ]), f = new Set([
        'swan-buttonbar'
    ]);
    'standard' !== i && f.add(`swan-buttonbar-${i}`);
    let O = useId(b), { selectedValue: _, onSelectedValueChange: g, selectedValues: j, onSelectedValuesChange: y } = useButtonbarState(r), S = 'radiogroup';
    switch(u){
        case 'toolbar':
            S = 'toolbar';
            break;
        case 'multi-select':
            S = 'group';
    }
    let h = _object_spread_props(_object_spread({}, d), {
        role: S,
        'aria-label': s,
        'aria-controls': p
    });
    return jsx(ButtonbarContext.Provider, {
        value: {
            name: O,
            variant: u,
            selectedValue: _,
            onSelectedValueChange: g,
            selectedValues: j,
            onSelectedValuesChange: y
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: o,
            classNames: f,
            props: h,
            children: c
        })
    });
});

export { Buttonbar };
